const Paths = {
    banner: '/banners/banner',
    bannerCreate: '/banners/banner/create',
};

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/Banner/paths.ts